import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

export function useGoogleSheetsExampleFile({ id, enabled }: { id?: number; enabled: boolean }) {
  const { data, ...arg } = useQuery<{ header: Record<string, string>; source: Record<string, string>[] }>(
    ['google-sheets-example-file', id],
    async () => {
      const { data } = await $api.get(`/v1/crm/drive/config/example/${id}`);

      return { header: data?.data?.[0] || [], source: [data?.data?.[1] || {}, {}] };
    },
    { enabled }
  );

  return { ...arg, ...data };
}
